(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["tonweb-mnemonic"] = factory();
	else
		root["TonWeb"] = root["TonWeb"] || {}, root["TonWeb"]["mnemonic"] = factory();
})(self, function() {
return 